<template>
  <div class="apply_box">
    <div v-if="showToask">
      <div class="notice">请保持银行卡号、身份证、预留手机号一致</div>
      <div class="pro_box">
        <span class="label">银行卡号</span>
        <input type="text"
               placeholder="请输入银行卡号"
               class="inputStyle"
               v-model="bankNum">
      </div>
      <div class="pro_box">
        <span class="label">预留手机号</span>
        <input type="text"
               placeholder="请输入手机号"
               class="inputStyle"
               v-model="tel">
      </div>
      <div class="loan_btn new_btn"
           @click="bindBank">确认</div>
    </div>
    <div v-else>
      <div class="header">
        <div class="loanMoney">借款金额(元)</div>
        <p class="title">{{loanInfo.loanMoney}}</p>
      </div>
      <div class="bg"></div>
      <div class="pro_detail">
        <div class="pro_item">
          <h1 class="h1"><span class="line"></span> 贷款详情</h1>
        </div>
        <div class="pro_item">
          <p>期限</p>
          <p>{{loanInfo.limit}}</p>
        </div>
        <div class="pro_item">
          <p>到账金额(元)</p>
          <p>{{loanInfo.money}}</p>
        </div>
        <div class="pro_item">
          <p>还款总额(元)</p>
          <p>{{loanInfo.allMoney}}(含利息{{loanInfo.moneyRate}})</p>
        </div>
        <div class="pro_item">
          <p>月利率</p>
          <p>{{loanInfo.rate}}%</p>
        </div>
      </div>
      <div class="bg"></div>
      <div class="pro_detail"
           v-if="showCard">
        <div class="pro_item">
          <h1 class="h1"><span class="line"></span> 收款银行卡</h1>
        </div>
        <div class="card_box">
          <div class="pro_item1">
            <img class="bank_icon left"
                 src=""
                 alt="">
            <p class="bank_name left">中国工商银行</p>
            <span class="card_num left">&nbsp;&nbsp;储蓄卡 | 尾号8511</span>
            <!-- <span class="replace_btn right">更换</span> -->
          </div>
        </div>
      </div>
      <div class="btn_box">
        <div class="loan_btn"
             @click="toPage('/afterLoan1/repaymentDetail')">确认借款</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      orderId: '',
      isActive: true,
      loanInfo: {
        loanMoney: '3000',
        limit: '3期',
        money: '2900.00',
        allMoney: '3000.00',
        moneyRate: '100',
      },
      page: '',
      showCard: false,//显示卡号
      showToask: false,//展示校验
      tel: '',
      bankNum: ''
    }
  },
  mounted () {
    this.page = this.$route.query.page;
    if (this.page == 1) {
      this.showCard = false;
      this.showToask = true;
      this.util.title('绑定借记卡');
      this.loanInfo = {
        loanMoney: '3000',
        limit: '3期',
        money: '3000.00',
        allMoney: '3090.00',
        moneyRate: '90',
        rate: 1,
      }
    } else if (this.page == 2) {
      this.showCard = true;
      this.showToask = false;
      this.util.title('确认借款');
      this.loanInfo = {
        loanMoney: '5000',
        limit: '3期',
        money: '5000.00',
        allMoney: '5200.00',
        moneyRate: '200',
        rate: 1.3,
      }
    } else if (this.page == 3) {
      this.showCard = true;
      this.showToask = false;
      this.util.title('确认借款');
      this.loanInfo = {
        loanMoney: '9000',
        limit: '6期',
        money: '9000.00',
        allMoney: '9702.00',
        moneyRate: '702',
        rate: 1.3,
      }
    }
  },
  methods: {
    //去分期
    toPage (pageUrl) {
      this.$router.push({
        path: pageUrl,
        query: {
          page: this.page
        }
      })
    },
    checkStatus () {
      this.isActive = !this.isActive;
    },
    bindBank () {
      if (this.bankNum.length < 16 && this.bankNum.length > 19) {
        this.util.toast({ msg: '请输入正确的银行卡号' });
      } else if (this.tel.length != 11) {
        this.util.toast({ msg: '请输入正确的手机号' });
      } else {
        this.showToask = false;
      }
    }
  }
}
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
}
/*  */
.notice {
  padding: 0.12rem 0 0.1rem 0;
  font-size: 0.14rem;
  color: #5983fc;
  background: #e6ebff;
  text-align: center;
  margin-bottom: 1rem;
}
.pro_box {
  clear: both;
  overflow: hidden;
  border-bottom: 1px solid #eee;
  padding: 0 0.15rem;
  background: #fff;
}
.label {
  font-size: 0.14rem;
  color: #666;
  display: inline-block;
  width: 0.75rem;
}
.inputStyle,
.inputStyle1 {
  padding: 0.15rem;
  color: #333;
  font-size: 0.14rem;
  width: 70%;
}
.new_btn {
  margin-top: 1rem !important;
}
/*  */
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.header {
  padding: 0.3rem 0 0.3rem 0;
  /* margin-bottom: 0.1rem; */
  background: #ffffff;
}
.loanMoney {
  color: #999;
  font-size: 0.14rem;
  text-align: center;
}
.pro_detail {
  background: #ffffff;
  margin-bottom: 0.1rem;
}
.title {
  color: #333;
  font-size: 0.3rem;
  text-align: center;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.pro_item .btn {
  color: #486cff;
  font-size: 0.14rem;
  text-align: center;
  margin: 0 auto;
  padding: 0.1rem;
}
.h1 {
  font-size: 0.16rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.info_box {
  font-size: 0.11rem;
  color: #333;
  padding: 0.1rem 0.15rem 0.36rem 0.15rem;
  background: #f7f7f7;
}
.info_box .agree {
  color: #486cff;
}
.icon_circle,
.icon_circleAct {
  position: relative;
  top: 0.02rem;
  margin-right: 0.05rem;
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url('../../assets/img/afterLoan/choice_unCheck.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.icon_circleAct {
  background: url('../../assets/img/afterLoan/checked.png') no-repeat top center;
  background-size: 100% 100%;
}
.bank_icon {
  display: inline-block;
  width: 0.32rem;
  height: 0.2rem;
  margin-right: 0.1rem;
  background: url('../../assets/img/afterLoan/bank_icon.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.bank_btn {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url('../../assets/img/afterLoan/add_btn.png') no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  text-align: center;
  margin-right: 0.1rem;
  position: relative;
  top: 0.02rem;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
}
.look {
  color: #486cff;
  font-size: 0.13rem;
  float: right;
}
.btn_box {
  margin-top: 0.3rem;
}
.pro_item1 {
  padding: 0.15rem;
  clear: both;
  overflow: hidden;
}
.xy_box {
  margin-top: 0.1rem;
}
</style>